import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MibLogo } from '../mib-header/mib-logo';
import { CopyrightAndLegalLink } from '../copyright-and-legal-link';

/**
 * Full-screen "welcome" placeholder shown while the room is connected but the
 * session has not started yet (waiting state).
 *
 * Reproduces the Figma waiting screen: centered Medinbox AI branding, a welcome
 * message and the animated (self-drawing) Medinbox diagram, with a copyright footer.
 */
@Component({
  selector: 'app-session-waiting',
  imports: [MibLogo, CopyrightAndLegalLink],
  templateUrl: './session-waiting.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col items-center' },
})
export class SessionWaiting {}
